module.exports = __webpack_public_path__ + "img/public-liability-insurance-footer.3aceba67.jpg";